import React from "react";
import LogoName from "../../../components/LogoName/logoName";
import Title from "../../../components/Title/title";
import styles from "./faceId.module.css";

import Button from "../../../components/Button/button";
import { useNavigate } from "react-router-dom";
import { APP_ROUTES } from "../../../router/Route";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useFaceIdRegister } from "../../../hook/useFaceIdRegister";

const FaceIdReg = () => {
  const navigation = useNavigate();
  useFaceIdRegister();
  return (
    <div className={styles.container}>
      <LogoName />
      <ToastContainer position="top-center" />
      <Title fontSize="35px" title="Регистрация. смотрите в камеру!" />
      <Title fontSize="35px" title="Регистрация. камерага каранг!" />
      <Button
        btnSize="large"
        btnType="outline"
        title="Назад"
        style={{
          marginTop: "30px",
        }}
        onPress={() => navigation(APP_ROUTES.WELCOME)}
      />
    </div>
  );
};

export default FaceIdReg;
